"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["children", "mt"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** a set of Button components */
  children: _propTypes.node,

  /** a set of Button components */
  mt: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])
};

var ButtonsContainer = function ButtonsContainer(_ref) {
  var children = _ref.children,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 4 : _ref$mt,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return children ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    flexWrap: "wrap",
    mt: mt
  }, props), children) : null;
};

ButtonsContainer.propTypes = propTypes;
ButtonsContainer.displayName = "Modules.ButtonsContainer";
var _default = ButtonsContainer;
exports["default"] = _default;